import { render, staticRenderFns } from "./PrelimsCrews.vue?vue&type=template&id=c6a056e8&scoped=true"
import script from "./PrelimsCrews.vue?vue&type=script&lang=js"
export * from "./PrelimsCrews.vue?vue&type=script&lang=js"
import style0 from "./PrelimsCrews.vue?vue&type=style&index=0&id=c6a056e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a056e8",
  null
  
)

export default component.exports